function addHardcodedRetailers () {
  if (window.theme.settings.template !== 'product.supadu') return
  if (!window.theme.productData || !window.theme.productData.variants || !window.theme.productData.variants.length) return
  const variant = window.theme.productData.variants.find(variant => variant.title === 'Default Title')
  if (!variant || !variant.sku) return
  const isbn13 = variant.sku
  window.theme.settings.bookDetailsSettings.hardcodedRetailers = [
    {
      label: 'Amazon',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=amazon`
    },
    {
      label: 'Barnes & Noble',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=barnesandnoble`
    },
    {
      label: 'Books-A-Million',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=booksamillion`
    },
    {
      label: 'Bookshop',
      path: `https://bookshop.org/a/397/${isbn13}`
    },
    {
      label: 'IndieBound',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=indiebound`
    },
    {
      label: 'Target',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=target`
    },
    {
      label: 'Walmart',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=walmar`
    }
  ]
}

function customFunctions () {
  addHardcodedRetailers()
}

module.exports = { customFunctions }
